function pick(obj, keys) {
  const isObject = target => {
    return Object.prototype.toString.call(target) === "[object Object]";
  };
  var res = {};
  if (typeof keys === "string") {
    if (keys in obj) {
      res[keys] = obj[keys];
    }
    return res;
  }

  var len = keys.length;
  var idx = -1;

  while (++idx < len) {
    var key = keys[idx];
    if (key in obj) {
      res[key] = obj[key];
    }
  }
  return res;
}
export default pick;
